import { P, match } from "ts-pattern";

import Minimap_Ancestor_AboveAllAncestors_BetweenDescendents from "./Minimap_Ancestor_AboveAllAncestors_BetweenDescendents.svg";
import Minimap_Ancestor_AboveAllAncestors_NotBetweenDescendents from "./Minimap_Ancestor_AboveAllAncestors_NotBetweenDescendents.svg";
import Minimap_Ancestor_BelowAllAncestors_BetweenDescendents from "./Minimap_Ancestor_BelowAllAncestors_BetweenDescendents.svg";
import Minimap_Ancestor_BelowAllAncestors_NotBetweenDescendents from "./Minimap_Ancestor_BelowAllAncestors_NotBetweenDescendents.svg";
import Minimap_Ancestor_BetweenAncestors_BetweenDescendents from "./Minimap_Ancestor_BetweenAncestors_BetweenDescendents.svg";
import Minimap_Ancestor_BetweenAncestors_NotBetweenDescendents from "./Minimap_Ancestor_BetweenAncestors_NotBetweenDescendents.svg";
import Minimap_Descendent_BetweenAncestors_AboveAllDescendents from "./Minimap_Descendent_BetweenAncestors_AboveAllDescendents.svg";
import Minimap_Descendent_BetweenAncestors_BelowAllDescendents from "./Minimap_Descendent_BetweenAncestors_BelowAllDescendents.svg";
import Minimap_Descendent_BetweenAncestors_BetweenDescendents from "./Minimap_Descendent_BetweenAncestors_BetweenDescendents.svg";
import Minimap_Descendent_NotBetweenAncestors_AboveAllDescendents from "./Minimap_Descendent_NotBetweenAncestors_AboveAllDescendents.svg";
import Minimap_Descendent_NotBetweenAncestors_BelowAllDescendents from "./Minimap_Descendent_NotBetweenAncestors_BelowAllDescendents.svg";
import Minimap_Descendent_NotBetweenAncestors_BetweenDescendents from "./Minimap_Descendent_NotBetweenAncestors_BetweenDescendents.svg";
import Minimap_Selected_AboveAllAncestors_AboveAllDescendents from "./Minimap_Selected_AboveAllAncestors_AboveAllDescendents.svg";
import Minimap_Selected_AboveAllAncestors_BelowAllDescendents from "./Minimap_Selected_AboveAllAncestors_BelowAllDescendents.svg";
import Minimap_Selected_AboveAllAncestors_BetweenDescendents from "./Minimap_Selected_AboveAllAncestors_BetweenDescendents.svg";
import Minimap_Selected_AboveAllAncestors_NoDescendents from "./Minimap_Selected_AboveAllAncestors_NoDescendents.svg";
import Minimap_Selected_BelowAllAncestors_AboveAllDescendents from "./Minimap_Selected_BelowAllAncestors_AboveAllDescendents.svg";
import Minimap_Selected_BelowAllAncestors_BelowAllDescendents from "./Minimap_Selected_BelowAllAncestors_BelowAllDescendents.svg";
import Minimap_Selected_BelowAllAncestors_BetweenDescendents from "./Minimap_Selected_BelowAllAncestors_BetweenDescendents.svg";
import Minimap_Selected_BelowAllAncestors_NoDescendents from "./Minimap_Selected_BelowAllAncestors_NoDescendents.svg";
import Minimap_Selected_BetweenAncestors_AboveAllDescendents from "./Minimap_Selected_BetweenAncestors_AboveAllDescendents.svg";
import Minimap_Selected_BetweenAncestors_BelowAllDescendents from "./Minimap_Selected_BetweenAncestors_BelowAllDescendents.svg";
import Minimap_Selected_BetweenAncestors_BetweenDescendents from "./Minimap_Selected_BetweenAncestors_BetweenDescendents.svg";
import Minimap_Selected_BetweenAncestors_NoDescendents from "./Minimap_Selected_BetweenAncestors_NoDescendents.svg";
import Minimap_Selected_NoAncestors_AboveAllDescendents from "./Minimap_Selected_NoAncestors_AboveAllDescendents.svg";
import Minimap_Selected_NoAncestors_BelowAllDescendents from "./Minimap_Selected_NoAncestors_BelowAllDescendents.svg";
import Minimap_Selected_NoAncestors_BetweenDescendents from "./Minimap_Selected_NoAncestors_BetweenDescendents.svg";
import Minimap_Selected_NoAncestors_NoDescendents from "./Minimap_Selected_NoAncestors_NoDescendents.svg";
import Minimap_Text_BetweenAncestors_BetweenDescendents from "./Minimap_Text_BetweenAncestors_BetweenDescendents.svg";
import Minimap_Text_BetweenAncestors_NotBetweenDescendents from "./Minimap_Text_BetweenAncestors_NotBetweenDescendents.svg";
import Minimap_Text_NotBetweenAncestors_BetweenDescendents from "./Minimap_Text_NotBetweenAncestors_BetweenDescendents.svg";
import Minimap_Text_NotBetweenAncestors_NotBetweenDescendents from "./Minimap_Text_NotBetweenAncestors_NotBetweenDescendents.svg";
import Minimap_Unconnected_BetweenAncestors_BetweenDescendents from "./Minimap_Unconnected_BetweenAncestors_BetweenDescendents.svg";
import Minimap_Unconnected_BetweenAncestors_NotBetweenDescendents from "./Minimap_Unconnected_BetweenAncestors_NotBetweenDescendents.svg";
import Minimap_Unconnected_NotBetweenAncestors_BetweenDescendents from "./Minimap_Unconnected_NotBetweenAncestors_BetweenDescendents.svg";
import Minimap_Unconnected_NotBetweenAncestors_NotBetweenDescendents from "./Minimap_Unconnected_NotBetweenAncestors_NotBetweenDescendents.svg";

/**
 * Fully specifies which of the 36 possible minimap SVGs to use to represent a cell in the canvas
 * minimap.
 *
 * To understand how this works, consider the following ASCII-ified example minimap. Here, the
 * minimap is actually a collection of stacked SVGs, with one cell per line.
 *
 *        ┏• cell1
 *      ┏○┫  cell2
 *      ┃•┃  cell3
 *     •┛ ┃  cell4
 *        ┗• cell5
 *
 * The role of this code is to encode enough information that we can precisely specify that `cell2`
 * should have an SVG that looks like `┏○┫`, so that it "matches up" with the SVGs for `cell1` and
 * `cell3`.
 *
 * There are, as we said, 36 possible SVGs. Each of these has 3 things:
 *
 *   - A mandatory single point, representing the cell itself. e.g., the selected point `┏○┫ cell2`,
 *     the direct ancestor point `•┛ ┃  cell4`, and so on.
 *   - An optional line to the left connecting to the direct ancestors, e.g, the direct connection
 *     to the ancestor point in `•┛ ┃  cell4`, or the "continuing" line in `┃•┃  cell3`, and so on.
 *   - An optional line to the right connecting to the direct descendents. This looks exactly like
 *     the left line.
 *
 * Most of the subtlety in this specification lies in the line drawing, which simply has many
 * permutations. For example there's the "dual unconnected line passthrough" case `┃•┃  cell3`,
 * there's the "connected direct ancestor + passthrough" case `•┛ ┃  cell4`, and so on.
 *
 * The most useful fields for determining the status of these lines is
 * `ancestorRangeSelectionStatus` and `descendentRangeSelectionStatus`, which let the SVG-rendering
 * routines know whether to render either terminal points like `•┛` or `┗•`, "continuing" lines like
 * `┃•┃`, connected continuing lines like `•┫`, and so on.
 */
export interface IconMinimapInfo {
	/**
	 * The relationship of this cell to the selected cell.
	 *
	 * This is in particular used to determine where to draw the dot in the SVG, for example:
	 *
	 *   - This cell is the currently-selected cell, e.g., `┏○┫  cell2`
	 *   - This cell is a direct ancestor, e.g., `•┛ ┃  cell4`
	 *   - This cell is a direct descendent, e.g., `   ┗• cell5`
	 *   - This cell is unconnected to the selected cell, e.g., `┃•┃  cell3`
	 */
	relationshipToSelectedCell:
		| "selectedCellDirectAncestor" // Selected cell depends directly on this cell.
		| "selectedCell" // The selected cell itself.
		| "selectedCellDirectDescendent" // Cell with direct dependency on selected cell.
		| "cellNoDirectRelationship"
		| "textCell"; // Text cells cannot be connected to a compute cell.

	/**
	 * Information about where this cell sits in relation to the direct ancestor cells. This is very
	 * helpful for determining how to draw the left-hand line in the SVG. For example:
	 *
	 *   - If this is the "last" ancestor node, the left-hand line would look like `•┛ ┃  cell4`
	 *   - If this is an unconnected cell between two ancestor nodes, the left-hand line would look
	 *     like `┃•┃  cell3`
	 *   - If this is the selected cell, but it's also above all the direct ancestor cells, the
	 *     left-hand line would look like `┏○┫  cell2`
	 *   - etc.
	 */
	directAncestorLineInfo: "above-all" | "between" | "below-all" | "none";

	/**
	 * Information about where this cell sits in relation to the direct descendent cells. This is
	 * very helpful for determining how to draw the right-hand line in the SVG. For example:
	 *
	 *   - If this is the "last" ancestor node, the right-hand line would look like `   ┗• cell5`
	 *   - If this is an unconnected cell between two ancestor nodes, the right-hand line would look
	 *     like `┃•┃  cell3`
	 *   - If this is the selected cell, but it's also between direct ancestor cells, the right-hand
	 *     line would look like `┏○┫  cell2`
	 *   - etc.
	 */
	directDescendentLineInfo: "above-all" | "between" | "below-all" | "none";
}

/**
 * The SVG that visualizes a cell's dependencies and dependents in the canvas minimap.
 *
 * A cell is represented with one of 36 possible minimap SVGs, and they are stacked on top of each
 * other to build a minimap of the entire canvas. Below is an ASCII-ified version of such a minimap,
 * wich each line representing an SVG for one cell, stacked to create a single minimap. Here the `○`
 * is the selected cell, and each `•` is another cell, with ASCII lines showing the dependency
 * structure of the cells.
 *
 *        ┏•
 *      ┏○┫
 *      ┃•┃
 *     •┛ ┃
 *        ┗•
 */
export const IconMinimap: React.FC<IconMinimapInfo> = ({
	relationshipToSelectedCell: cellType,
	directAncestorLineInfo: ancestorRangeSelectionStatus,
	directDescendentLineInfo: descendentRangeSelectionStatus,
}) => {
	return (
		match({ cellType, ancestorRangeSelectionStatus, descendentRangeSelectionStatus })
			//
			// •┓ ┃
			//
			.with(
				{
					cellType: "selectedCellDirectAncestor",
					ancestorRangeSelectionStatus: "above-all",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Ancestor_AboveAllAncestors_BetweenDescendents />
			)
			//
			// •┓
			//
			.with(
				{
					cellType: "selectedCellDirectAncestor",
					ancestorRangeSelectionStatus: "above-all",
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Ancestor_AboveAllAncestors_NotBetweenDescendents />
			)
			//
			// •┛ ┃
			//
			.with(
				{
					cellType: "selectedCellDirectAncestor",
					ancestorRangeSelectionStatus: "below-all",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Ancestor_BelowAllAncestors_BetweenDescendents />
			)
			//
			// •┛
			//
			.with(
				{
					cellType: "selectedCellDirectAncestor",
					ancestorRangeSelectionStatus: "below-all",
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Ancestor_BelowAllAncestors_NotBetweenDescendents />
			)
			//
			// •┫ ┃
			//
			.with(
				{
					cellType: "selectedCellDirectAncestor",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Ancestor_BetweenAncestors_BetweenDescendents />
			)
			//
			// •┫
			//
			.with(
				{
					cellType: "selectedCellDirectAncestor",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Ancestor_BetweenAncestors_NotBetweenDescendents />
			)
			//
			// •┫ ┏•
			//
			.with(
				{
					cellType: "selectedCellDirectDescendent",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "above-all",
				},
				() => <Minimap_Descendent_BetweenAncestors_AboveAllDescendents />
			)
			//
			// •┫ ┗•
			//
			.with(
				{
					cellType: "selectedCellDirectDescendent",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "below-all",
				},
				() => <Minimap_Descendent_BetweenAncestors_BelowAllDescendents />
			)
			//
			// ┃ ┣•
			//
			.with(
				{
					cellType: "selectedCellDirectDescendent",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Descendent_BetweenAncestors_BetweenDescendents />
			)
			//
			//   ┏•
			//
			.with(
				{
					cellType: "selectedCellDirectDescendent",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: "above-all",
				},
				() => <Minimap_Descendent_NotBetweenAncestors_AboveAllDescendents />
			)
			//
			//   ┗•
			//
			.with(
				{
					cellType: "selectedCellDirectDescendent",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: "below-all",
				},
				() => <Minimap_Descendent_NotBetweenAncestors_BelowAllDescendents />
			)
			//
			//   ┣•
			//
			.with(
				{
					cellType: "selectedCellDirectDescendent",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Descendent_NotBetweenAncestors_BetweenDescendents />
			)
			//
			// ┏○┓
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "above-all",
					descendentRangeSelectionStatus: "above-all",
				},
				() => <Minimap_Selected_AboveAllAncestors_AboveAllDescendents />
			)
			//
			// ┏○┛
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "above-all",
					descendentRangeSelectionStatus: "below-all",
				},
				() => <Minimap_Selected_AboveAllAncestors_BelowAllDescendents />
			)
			//
			// ┏○┫
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "above-all",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Selected_AboveAllAncestors_BetweenDescendents />
			)
			//
			// ┏○
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "above-all",
					descendentRangeSelectionStatus: "none",
				},
				() => <Minimap_Selected_AboveAllAncestors_NoDescendents />
			)

			//
			// ┗○┓
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "below-all",
					descendentRangeSelectionStatus: "above-all",
				},
				() => <Minimap_Selected_BelowAllAncestors_AboveAllDescendents />
			)
			//
			// ┗○┛
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "below-all",
					descendentRangeSelectionStatus: "below-all",
				},
				() => <Minimap_Selected_BelowAllAncestors_BelowAllDescendents />
			)
			//
			// ┗○┫
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "below-all",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Selected_BelowAllAncestors_BetweenDescendents />
			)
			//
			// ┗○
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "below-all",
					descendentRangeSelectionStatus: "none",
				},
				() => <Minimap_Selected_BelowAllAncestors_NoDescendents />
			)
			//
			// ┣○┓
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "above-all",
				},
				() => <Minimap_Selected_BetweenAncestors_AboveAllDescendents />
			)
			//
			// ┣○┛
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "below-all",
				},
				() => <Minimap_Selected_BetweenAncestors_BelowAllDescendents />
			)
			//
			// ┣○┫
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Selected_BetweenAncestors_BetweenDescendents />
			)
			//
			// ┣○
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "none",
				},
				() => <Minimap_Selected_BetweenAncestors_NoDescendents />
			)
			//
			//  ○┓
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "none",
					descendentRangeSelectionStatus: "above-all",
				},
				() => <Minimap_Selected_NoAncestors_AboveAllDescendents />
			)
			//
			//  ○┛
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "none",
					descendentRangeSelectionStatus: "below-all",
				},
				() => <Minimap_Selected_NoAncestors_BelowAllDescendents />
			)
			//
			//  ○┫
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "none",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Selected_NoAncestors_BetweenDescendents />
			)
			//
			//  ○
			//
			.with(
				{
					cellType: "selectedCell",
					ancestorRangeSelectionStatus: "none",
					descendentRangeSelectionStatus: "none",
				},
				() => <Minimap_Selected_NoAncestors_NoDescendents />
			)
			//
			// ┃•┃
			//
			.with(
				{
					cellType: "textCell",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Text_BetweenAncestors_BetweenDescendents />
			)
			//
			// ┃•
			//
			.with(
				{
					cellType: "textCell",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Text_BetweenAncestors_NotBetweenDescendents />
			)
			//
			//  •┃
			//
			.with(
				{
					cellType: "textCell",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Text_NotBetweenAncestors_BetweenDescendents />
			)
			//
			//  •
			//
			.with(
				{
					cellType: "textCell",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Text_NotBetweenAncestors_NotBetweenDescendents />
			)
			//
			// ┃•┃
			//
			.with(
				{
					cellType: "cellNoDirectRelationship",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Unconnected_BetweenAncestors_BetweenDescendents />
			)
			//
			// ┃•
			//
			.with(
				{
					cellType: "cellNoDirectRelationship",
					ancestorRangeSelectionStatus: "between",
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Unconnected_BetweenAncestors_NotBetweenDescendents />
			)
			//
			//  •┃
			//
			.with(
				{
					cellType: "cellNoDirectRelationship",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: "between",
				},
				() => <Minimap_Unconnected_NotBetweenAncestors_BetweenDescendents />
			)
			//
			//  •
			//
			.with(
				{
					cellType: "cellNoDirectRelationship",
					ancestorRangeSelectionStatus: P.not("between"),
					descendentRangeSelectionStatus: P.not("between"),
				},
				() => <Minimap_Unconnected_NotBetweenAncestors_NotBetweenDescendents />
			)
			.otherwise(() => {
				// NOTE: This technically should never happen but `.exhaustive()` causes the
				// TypeScript compiler gives us a error saying "type instantiation is excessively
				// deep and possibly infinite." So here we are.
				return <Minimap_Unconnected_NotBetweenAncestors_NotBetweenDescendents />;
			})
	);
};
